var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBar = function SvgBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 8 50 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m25.003 24.154 19.427-9.368 2.227 6.066L25.889 36.45zM6.599 21.948l15.622 2.56.911 12.636-19.567-6.26zM31.206 9.343 4.542 19.302 0 32.678l24.938 7.978L50 21.833l-3.76-10.241zm-7.878 12.513-12.262-2.009 20.428-7.629 9.02 1.351z",
    clipRule: "evenodd"
  })));
};
export default SvgBar;